import ApgIcon from './ApgIcon';

export * from './icon';
export default ApgIcon;
